/**
 * Keeps #model-details-{sectionId} in sync when variants change, without editing variant-selects.js.
 * Uses the same pub/sub + section fetch pattern as the theme variant picker.
 */
(function () {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  var abortController = null;

  subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, function (payload) {
    var data = payload && payload.data;
    if (!data || !data.selectedOptionValues || !data.selectedOptionValues.length) return;

    var target = data.target || (data.event && data.event.target);
    if (!target) return;

    // Robust "closest" for cases where target is an <option> / label on mobile.
    var picker = null;
    if (typeof target.closest === 'function') {
      picker = target.closest('variant-radios, variant-selects');
    }

    if (!picker) {
      var node = target;
      while (node && !picker) {
        if (node.nodeType === 1 && typeof node.matches === 'function') {
          if (node.matches('variant-radios') || node.matches('variant-selects')) {
            picker = node;
            break;
          }
        }
        node = node.parentElement || node.parentNode;
      }
    }

    if (!picker) return;

    var sectionId = picker.dataset.section;
    var productUrl = picker.dataset.url;
    if (!sectionId || !productUrl) return;

    var liveRoot = document.getElementById('model-details-' + sectionId);
    if (!liveRoot) return;

    if (abortController) abortController.abort();
    abortController = new AbortController();

    var base = productUrl.split('?')[0];
    var params = new URLSearchParams();
    params.set('section_id', sectionId);
    params.set('option_values', data.selectedOptionValues.join(','));

    fetch(base + '?' + params.toString(), { signal: abortController.signal })
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextRoot = doc.getElementById('model-details-' + sectionId);
        if (!nextRoot || !liveRoot) return;
        liveRoot.innerHTML = nextRoot.innerHTML;
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
      });
  });
})();
